import { render, staticRenderFns } from "./SendReports.vue?vue&type=template&id=e9b47276"
import script from "./SendReports.vue?vue&type=script&lang=js"
export * from "./SendReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports